import { useEffect, useState } from "react";
import { cachedGet, fileUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";
import { SectionTitle } from "@/components/EventsGrid";

export default function Glimpses() {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    cachedGet("/gallery").then(({ data }) => setPhotos(data)).catch(() => {});
  }, []);

  if (photos.length === 0) return null;

  return (
    <section id="glimpses" className="px-6 md:px-12 py-14 md:py-16" data-testid="glimpses-section">
      <SectionTitle testid="glimpses-heading">GLIMPSES OF DEVOTION</SectionTitle>
      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {photos.slice(0, 6).map((p, i) => (
          <Reveal key={p.id} delay={i * 0.05} y={20}>
            <figure className="group relative rounded-lg overflow-hidden border border-bone/10 aspect-[4/5]" data-testid={`glimpse-${i}`}>
              <img src={fileUrl(p.image_url)} alt={p.caption || "The Band Sumiran live"}
                className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-[1.06] transition-[opacity,transform] duration-700" loading="lazy" />
              {p.caption && (
                <figcaption className="absolute bottom-0 inset-x-0 p-3 bg-gradient-to-t from-ink/95 to-transparent text-[10px] text-bone/80 opacity-0 group-hover:opacity-100 transition-opacity">
                  {p.caption}
                </figcaption>
              )}
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
